import React from "react";
import { Link } from "react-router-dom";
import {
  ClipboardList,
  MapPinned,
  MapPin,
  PackageSearch,
  ShieldCheck,
  UserRoundCog,
} from "lucide-react";

export default function AdminPage() {
  return (
    <div className="mx-auto max-w-[1200px] space-y-6 px-4 py-6 pb-28 md:py-8 md:pb-10">
      <header><div className="flex min-w-0 items-start gap-3"><div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-inset text-accent"><ShieldCheck /></div><div className="min-w-0"><p className="text-sm font-medium text-secondary">Private controls</p><h1 className="mt-1 text-2xl font-semibold tracking-tight text-primary">Admin</h1><p className="mt-1 max-w-2xl text-sm text-secondary">Manage CatchCompass accounts, lake/peg mapping and the shared tackle library.</p></div></div></header>
      <div className="grid gap-3 md:grid-cols-2">
        <AdminCard to="/admin/accounts" icon={<UserRoundCog />} title="Account Access" text="Approve new anglers, suspend access or review account status." />
        <AdminCard to="/admin/lakes" icon={<MapPinned />} title="Lake Management" text="Maintain the known water directory and canonical lake records." />
        <AdminCard to="/admin/lake-reviews" icon={<ClipboardList />} title="Lake Reviews" text="Review, approve, link or reject community-submitted lakes." />
        <AdminCard to="/admin/tackle" icon={<PackageSearch />} title="Tackle Library" text="Review baits, rigs and lead systems. Approve new items or link duplicates to the canonical library." />
        <AdminCard to="/admin/swim-reviews" icon={<MapPin />} title="Peg Reviews" text="Approve or reject angler-submitted peg locations before they become shared." />
      </div>
    </div>
  );
}

function AdminCard({ to, icon, title, text }: { to: string; icon: React.ReactNode; title: string; text: string }) {
  return <Link to={to} className="group rounded-xl border border-border bg-raised p-5 transition-colors hover:bg-inset"><div className="flex items-start gap-3"><div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-inset text-accent">{icon}</div><div className="min-w-0"><h2 className="font-semibold text-primary">{title}</h2><p className="mt-1 text-sm leading-6 text-secondary">{text}</p></div></div></Link>;
}
